/**
 * Generate a UUID v4 (random-based UUID)
 * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx where x is random hex (0-f) and y is one of 8,9,a,b
 *
 * @returns {string} UUID v4 formatted string
 */

export default function generateUuid() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // Set version (4) and variant bits according to RFC 4122
  // eslint-disable-next-line no-bitwise
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  // eslint-disable-next-line no-bitwise
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 1

  // Convert to hex string with dashes
  return [bytes.slice(0, 4), bytes.slice(4, 6), bytes.slice(6, 8), bytes.slice(8, 10), bytes.slice(10, 16)]
    .map((part) => Array.from(part)
        .map((b) => b.toString(16).padStart(2, '0'))
        .join(''))
    .join('-');
}
